export enum AsyncComponentCompanyEnum {
  CompanySettings = 'CompanySettings',
  CompanyProfile = 'CompanyProfile',
  AccountSettings = 'AccountSettings',
  CompanyListForm = 'CompanyListForm',
  CompanyMutate = 'CompanyMutate',
  CompanyTabs = 'CompanyTabs',
  CompanyList = 'CompanyList',
}

export const companyComponents = {
  [ AsyncComponentCompanyEnum.CompanySettings ]: () => import( '@/views/settings/CompanySettings.vue' ),
  [ AsyncComponentCompanyEnum.CompanyProfile ]: () => import( '@/components/company/CompanyProfile.vue' ),
  [ AsyncComponentCompanyEnum.AccountSettings ]: () => import( '@/views/settings/AccountSettings.vue' ),
  [ AsyncComponentCompanyEnum.CompanyListForm ]: () => import( '@/components/company/CompanyListForm.vue' ),
  [ AsyncComponentCompanyEnum.CompanyMutate ]: () => import( '@/views/company/companyMutate/CompanyMutate.vue' ),
  [ AsyncComponentCompanyEnum.CompanyTabs ]: () => import( '@/components/company/CompanyTabs.vue' ),
  [ AsyncComponentCompanyEnum.CompanyList ]: () => import( '@/views/company/companyList/CompanyList.vue' ),

}
